var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0_363_309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_363_309",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_363_309",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_363_309",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADoUlEQVR4nO2dz0sWQRyHX4uCIoQsw8JTQZAXQa1OYn9Ct+zHOQI72Q+JiOxUXco6BBJ0kvLXIYrCW3Wo6BiCRgfpkBUFQWpBhT0xOILIvq8z77vszu5+HtjjzHy/+zC7O7uzM6WSEEIIIYQQQgghhBAFBVgH7AeOA71AX86OXptbh8m1FCrALuA28Jni8Am4BewshQJQB1wAflJcFmzvqUtbxiZgNO2zERAj5pyk2TMepH0GAmQ8lZ5iL1Mimr40buDmuimiWUj0Rm+fpkRlBpIcZxTp0bZaviQyTgEOVB1i8ehIQsiJtLPMEEeTEHI27SwzxJkkhPSnnWWG6JeQsJCQwMiMkBmgB2gBmoEuYBD4Q77IhJCnwJYydXcCP8gPwQuZKSdjRf3d5IfghfQ4vkWeJh8EL6TFsY075IPghTQ7tnGVfBC8kC7HNsbIB8ELGXSofxswRz4IXogZZ3SuUf8Q+SF4IdhxRvfq7862ZwyRLzIhZJlp+zR13U4MmCN/ZEpIEeiXkLCQkMDIhJBJO9sx6ngMfC9T7hcwUaHsqwpt/rX3rBfAQ+Al8AH4R8GFDKw1qw9oAj5GyGh1iO1UxJvlI8DWCvPLTJnXFFTIHsc2bqwqN+FYbr2V9wY46JnXYeA9BRPSWGUbox7xXQI2Vplbvb1sxoWExDQR8B7xICFxAGwAnlE7EhIXZrI0MC8hpTCE2DiuSEgpKCH19qlNQqhRiBm3AMPAV+A3MAVcBDZ71vNIQqhNiJnkbCVE8RbY7lHXyRrylRBgXwUZyzzxqO9QDflKCHDXMZZWx/r21pCvhADvHGM57VhfYw35SghLN3EXLjvWJyEkI8TpZElISUK8kBAvJAQJ8UJC4kZCvJAQJMQLCYkbCfFCQpAQLyQkbiTECwlBQryQkMCE7KiyjTGP+L7FebJMzHkWUu1fuJMuS6/aidquM9pHHGPJ9SfcKbvQTIOZkR5xNJtFv4DFiLJm4c3dZcqZow147hHLol3HvblMfQ1WhusXyEwKKRr9EhIWElJEIVoEM7BFMI95BFR0upMQYnbPEW60J/WHkdlZRlRmNrFtK+w2P6IyNxORseJ1Qh7XJokL8+dVU2JCrBSz55KI5lyiMlYsVnm/TEBFZjy1zcHspmBmIyyxxHBqm4Kt6innC74F0rwdMKe7bV7Eb8QDBXsknjVPU4nfwKsYp7TbEb15vX0tZ0evza0tqB4hhBBCCCGEEEIIIUQpWf4DvXQ1bN2XwrEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFill);
export default __webpack_public_path__ + "static/media/linkedin-fill.4bee4c69a1d09e997fa775c9bef8eba0.svg";
export { ForwardRef as ReactComponent };